export enum ModuleStatusEnum {
    locked = 'locked',
    active = 'active',
    justUnlocked = 'justUnlocked'
}
